import { Component, Input } from '@angular/core';
import { TrainingAssistantChartProposal } from '../../dtos/training-assistant-chat';

/** Delegates to the dashboard page while it is open (see ThomasAppConfig.chartHost). open returns why the
 *  editor could not be opened, or null once it is open. */
export interface ThomasChartActions {
  blockReason(proposal: TrainingAssistantChartProposal, companyId: number | undefined): string | null;
  open(proposal: TrainingAssistantChartProposal, companyId: number | undefined): string | null;
}

/** Lives in the card inputs so it survives dx-chat re-rendering the message. */
export interface ThomasChartCardState {
  companyId: number | undefined;
  error: string | null;
}

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector -- shared Thomas markup uses the js- prefix in every app
  selector: 'js-thomas-chart-card',
  template: `
    <div class="thomas-card">
      <div class="thomas-card-title">
        <span class="thomas-card-name">{{ heading }}</span>
        <span class="thomas-card-id">{{ proposal.dashboardName }}</span>
      </div>
      <div class="thomas-card-facts">
        @for (setting of proposal.settings; track $index) {
          <span class="thomas-card-label">{{ setting.label }}</span>
          <span class="thomas-card-value">{{ setting.value }}</span>
        }
      </div>
      <div class="thomas-card-actions">
        <button type="button" class="thomas-button-primary" [disabled]="!!blockReason" (click)="openEditor()">Open in editor</button>
      </div>
      @if (state.error || blockReason; as hint) {
        <span class="thomas-card-hint">{{ hint }}</span>
      } @else {
        <span class="thomas-card-hint">Check the settings in the editor, then click Save.</span>
      }
    </div>
  `
})
export class ThomasChartCardComponent {

  @Input({ required: true }) proposal!: TrainingAssistantChartProposal;
  @Input({ required: true }) actions!: ThomasChartActions;
  @Input({ required: true }) state!: ThomasChartCardState;

  get heading(): string {
    const kind = this.proposal.cardType === 'metric' ? 'metric' : 'chart';
    return this.proposal.mode === 'create' ? `New ${kind}` : `Change ${kind}`;
  }

  get blockReason(): string | null {
    return this.actions.blockReason(this.proposal, this.state.companyId);
  }

  openEditor() {
    this.state.error = this.actions.open(this.proposal, this.state.companyId);
  }
}
